export const calcRatio = (width, height, defaultRatio = 50) =>
  width > 0 && height > 0 ? (100 * height) / width : defaultRatio;

export const makeSrcSet = (url, width) =>
  `${url}?w=${width} 1x, ${url}?w=${Math.ceil(1.5 * width)} 1.5x`;
